import { Component, Fragment } from 'react'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import Modal from 'react-modal'
import find from 'lodash/find'
import './styles.sass'
import API from '../../api'
import { isValidEmail } from '../../utils'
import DateFormat from '../helpers/DateFormat'
import Select from 'react-select'
import { autosuggestStyles } from '../search/FiltersLa'
import { FormRow, TripDates, ContactPerson, WhatAreYouLooking, OrderReference } from './booking-enquire'
const defaultState = {
  kind: 0,
  firstDay: '',
  lastDay: '',
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  existing_reservation_reference: '',
  number_divers: 0,
  number_guests: 0,
  number_dives_per_diver: 0,
  number_rooms: 0,
  is_diving: false,
  is_accommodation_and_diving: false,
  is_liveaboard_trip: false,
  submitted: false,
  errors: {},
}

const ENQUIRE_TYPES = [
  { value: 0, title: <FormattedMessage id='booking_enquiry' defaultMessage='Booking enquiry' /> },
  { value: 10, title: <FormattedMessage id='group_booking_enquiry' defaultMessage='Group booking enquiry' /> },
  { value: 50, title: <FormattedMessage id='existing_reservation' defaultMessage='Existing reservation' /> },
  { value: 30, title: <FormattedMessage id='other' defaultMessage='Other' /> },
]

export default class BookingEnquirePopup extends Component {
  constructor(props) {
    super(props)

    this.state = defaultState
  }

  onChange = (name, value) => {
    this.setState({
      [name]: value,
    }, () => {
      if(this.state.submitted) {
        this.validate()
      }
    })
  }

  submit = (e) => {
    e.preventDefault()

    this.setState({
      submitted: true,
    })

    if(this.validate()) {
      let obj = { ...this.state }
      if(this.state.kind !== 0 && this.state.kind !== 10) {
        obj.firstDay = undefined
        obj.lastDay = undefined
      } else if(this.state.kind !== 50) {
        obj.existing_reservation_reference = undefined
      }
      API('shop/booking_enquire/', false, true)
        .post(obj)
        .then(() => {
          this.setState({
            ...defaultState,
            finished: true,
          })
        })
    }

    return false
  }

  setPhoneInstance = (instance) => {
    this.phoneInstance = instance
  }

  validate() {
    let errors = {}

    if(!this.state.first_name) {
      errors.first_name = true
    }

    if(!this.state.last_name) {
      errors.last_name = true
    }

    if(!this.state.email) {
      errors.email = true
    } else if(!isValidEmail(this.state.email)) {
      errors.email = true
    }

    if(!this.state.phone) {
      errors.phone = true
    } else if(this.phoneInstance && !this.phoneInstance.isValidNumber()) {
      errors.phone = true
    }

    if(this.state.kind === 0 || this.state.kind === 10) {
      if(!this.state.firstDay) {
        errors.firstDay = true
      }
      if(!this.state.lastDay) {
        errors.lastDay = true
      }
      if(!this.state.number_divers) {
        errors.number_divers = true
      }
    } else if(this.state.kind === 50) {
      if(!this.state.existing_reservation_reference) {
        errors.existing_reservation_reference = true
      }
    }

    this.setState({
      errors,
    })

    return Object.keys(errors).length === 0
  }

  render() {
    const { errors, kind } = this.state
    const { shop, title } = this.props

    const SelectValue = find(ENQUIRE_TYPES, function(item) {
      return item.value === kind
    })

    return (<Modal
      isOpen={this.props.isOpen}
      onRequestClose={this.props.closeModal}
      ariaHideApp={false}
      className='Modal react-popup form-popup'
      overlayClassName='Overlay'
      contentLabel='Booking enquire popup'>
      <span className='close-btn' onClick={this.props.closeModal} />
      { this.state.finished ? (
        <div className='form-popup-content'>
          <p><FormattedMessage id='booking_enquire.finished' defaultMessage='Thank you for your enquiry, we will get back to you with some offers as soon as possible' /></p>
        </div>
      ) : (
        <div className='form-popup-content'>
          <h3>{ title || <FormattedMessage id='contact_us' defaultMessage='Contact us' /> }</h3>

          { shop ? (
            <Fragment>
              <div className='shop-detail'>
                <div className='img' style={{ backgroundImage: `url(${shop.background})` }} />
                <ul>
                  <li><span className='shop-title' ng-bind='selectedShop.info.title' /></li>
                  <li>
                    <span className='bold' translate='translate'><FormattedMessage id='itinerary' defaultMessage='Itinerary' />:&nbsp;</span>
                    <span>{ shop.itinerary.title }</span>
                  </li>
                  <li>
                    <span className='bold' translate='translate'><FormattedMessage id='duration' defaultMessage='Duration' />:&nbsp;</span>
                    <FormattedMessage id='night_qty' values={
                      { qty: shop.duration }
                    } defaultMessage='{qty, plural, one {# night} other {# nights}}' />
                  </li>
                  <li>
                    <span className='bold'><FormattedMessage id='departure' defaultMessage='Departure' />:&nbsp;</span>
                    <span><DateFormat date={shop.startDate} /></span>
                  </li>
                  <li>
                    <span className='bold' translate='translate'><FormattedMessage id='arrival' defaultMessage='Arrival' />:&nbsp;</span>
                    <span><DateFormat date={shop.endDate} /></span>
                  </li>
                </ul>
              </div>
              <p>
                <FormattedMessage id='booking_enquire.text2' defaultMessage='Please provide us with your broad requirements and our dive travel specialists will get back to you regarding the selected vessel and itinerary, but also other possible options.' />
              </p>
            </Fragment>
          ) : (<p>
            <FormattedMessage id='booking_enquire.text' defaultMessage='Please provide us with your requirements and our dive travelspecialists will get back to you with a short list of options and packages to choose from' />
          </p>)}
          <form name='enquireForm' noValidate='novalidate' onSubmit={this.submit}>
            <FormRow title={<FormattedMessage id='what_you_like_to_contact' defaultMessage='What would you like to contact us about?' />}>
              <Select
                onChange={(item) => { console.log(item); this.onChange('kind', item.value) }}
                value={SelectValue}
                options={ENQUIRE_TYPES}
                styles={{
                  ...autosuggestStyles,
                  control: styles => ({
                    ...styles,
                    background: '#f9f9f9',
                    borderRadius: 2,
                    border: '1px solid #dde3e6',
                  }),
                  valueContainer: styles => ({
                    ...styles,
                  }),
                }}
                isSearchable={false}
                getOptionLabel={option => option.title}
                getOptionValue={option => option.id}
                className='select-container'
                classNamePrefix='select-container' />
            </FormRow>
            {
              kind === 0 || kind === 10 ? (
                <TripDates onChange={this.onChange}
                  dateTo={this.state.lastDay}
                  dateFrom={this.state.firstDay}
                  errors={errors} />
              ) : ''
            }
            {
              kind === 50 ? (
                <OrderReference onChange={this.onChange} errors={errors} reference={this.state.existing_reservation_reference} />
              ) : ''
            }
            <ContactPerson
              onChange={this.onChange}
              errors={errors}
              firstName={this.state.first_name}
              lastName={this.state.last_name}
              email={this.state.email}
              phone={this.state.phone}
              setPhoneInstance={this.setPhoneInstance}
              showTextArea={kind !== 0 && kind !== 10} />
            {
              kind === 0 || kind === 10 ? (
                <WhatAreYouLooking
                  onChange={this.onChange}
                  errors={errors}
                  isDiving={this.state.is_diving}
                  isAccommodationAndDiving={this.state.is_accommodation_and_diving}
                  isLiveaboardTrip={this.state.is_liveaboard_trip}
                  numberDivers={this.state.number_divers}
                  numberGuests={this.state.number_guests}
                  numberDivesPerDiver={this.state.number_dives_per_diver}
                  description={this.state.description}
                  numberRooms={this.state.number_rooms}
                />) : '' }
            <div className='form-bottom'>
              <div>
                <p>
                  <FormattedHTMLMessage id='booking_enquire.hint' defaultMessage='Fine print: Don`t worry, there isn`t any! <br>This is only an enquiry and doesn`t commit you to anything. <br>
                  Sit back and relax while we do the work for you :)' />
                </p>
                <br />
                <p><FormattedMessage id='booking_enquire.mandatory' defaultMessage='* mandatory fields' /></p>
                <p className='error-booking-enquire' ng-show='enquireForm.$invalid && enquireForm.$submitted'>
                  <FormattedMessage id='booking_enquire.mandatory_error' defaultMessage='Some mandatory fields are incomplete, please review your enquiry and try to submit again' />
                </p>
              </div>
              <div>
                <button className='btn-red' type='submit'>
                  <FormattedMessage id='send_request' defaultMessage='Send request' />
                </button>
              </div>
            </div>
          </form>
        </div>)
      }
    </Modal>)
  }
}
